import React, { useState } from "react";
import last from "../../Assets/Images/AssignUserToRole/last.png";
import first from "../../Assets/Images/AssignUserToRole/first.png";
import next from "../../Assets/Images/AssignUserToRole/next.png";
import before from "../../Assets/Images/AssignUserToRole/before.png";
// import { imageListClasses } from "@mui/material";

function EmployeeTable({ employees, onToggleSelected }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [collapsed, setCollapsed] = useState(false);

  const handleCollapseClick = () => {
    setCollapsed(!collapsed);
  };

  const handleCheckboxChange = (index) => {
    // Adjust index based on pagination
    const adjustedIndex = (currentPage - 1) * itemsPerPage + index;
    onToggleSelected(adjustedIndex);
  };

  const totalPages = Math.ceil(employees.length / itemsPerPage);
  const currentPageData = employees.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  return (
    <div>
      <table className="aur-table">
        {/* Table Headings */}
        <thead className="aur-table-head">
          <tr>
            {/* <th></th> For checkbox */}
            <th style={{ width: "40vh" }}>
              <div style={{ marginLeft: "30px" }}>NAME</div>
            </th>
            <th>STAFF NUMBER</th>
            <th>JOB TITLE</th>
            <th>MANAGER NAME</th>
            <th
              style={{
                display: "flex",
                // justifyContent: "space-between",
                alignItems: "center",
                // backgroundColor: "red",
                height: "30px",
              }}
            >
              <div style={{display:"flex", alignItems:"center", justifyContent:'space-between', width:"100%" }}> 
                <span style={{ }}>STATUS</span>
                {/* <button
                onClick={handleCollapseClick}
                className="aur-collapse-btn-sign"
              >
                {collapsed ? (
                  <img src={plus} style={{ width: "14px", height: "auto" }} />
                ) : (
                  <img src={minus} />
                )}
              </button> */}
                <div
                  // style={{ textAlign: "right" }}
                  className="accordion-btn"
                  onClick={handleCollapseClick}
                >
                  {collapsed ? (
                    <div className="minus"></div>
                  ) : (
                    <div className="plus">+</div>
                  )}
                </div>
              </div>
            </th>
          </tr>
        </thead>
        {/* Table Body */}
        {!collapsed && (
          <>
            <tbody className="aur-table-body">
              {currentPageData.map((employee, index) => (
                <tr key={employee.staff_number}>
                  {/* <td></td> */}
                  {/* <td>
                  <input
                    type="checkbox"
                    checked={employee.selected || false}
                    onChange={() => handleCheckboxChange(index)}
                  />
                </td> */}
                  <td>
                    <input
                      type="checkbox"
                      checked={employee.selected || false}
                      onChange={() => handleCheckboxChange(index)}
                      style={{ marginRight: "20px" }}
                    />
                    {`${employee.emp_first_name} ${employee.emp_last_name}`}
                  </td>
                  <td>{employee.staff_number}</td>
                  <td>{employee.designation}</td>
                  <td>{employee.manager_name}</td>
                  <td>{employee.status}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="aur-tfoot">
              <tr>
                <td colspan="6">
                  {totalPages > 1 && (
                    <div>
                      <div className="aur-page-btn-container">
                        <button
                          className="aur-page-btn"
                          onClick={() => handlePageClick(1)}
                        >
                          <img
                            style={{ width: "13px", height: "" }}
                            src={first}
                            alt=""
                          />
                        </button>
                        <button
                          className="aur-page-btn"
                          onClick={handlePreviousPage}
                        >
                          <img
                            style={{ width: "8px", height: "" }}
                            src={before}
                            alt=""
                          />
                        </button>
                        {Array.from(
                          { length: totalPages },
                          (_, i) => i + 1
                        ).map((page) => (
                          <button
                            key={page}
                            onClick={() => handlePageClick(page)}
                            className="aur-page-btn aur-page-btn-number"
                            style={{
                              // marginRight: "5px",
                              backgroundColor:
                                currentPage === page ? "#46B7B2" : "#fff",
                              color: currentPage === page ? "#fff" : "#000",
                            }}
                          >
                            {page}
                          </button>
                        ))}
                        <button
                          className="aur-page-btn"
                          onClick={handleNextPage}
                        >
                          <img
                            style={{ width: "8px", height: "" }}
                            src={next}
                            alt=""
                          />
                        </button>
                        <button
                          className="aur-page-btn"
                          onClick={handleLastPage}
                        >
                          <img
                            style={{ width: "13px", height: "" }}
                            src={last}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            </tfoot>
          </>
        )}
      </table>
      {/* Pagination Buttons */}
      {/* {totalPages > 1 && (
        <div style={{ marginTop: "10px" }}>
          <button onClick={() => handlePageClick(1)}>First</button>
          <button onClick={handlePreviousPage}>Before</button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => handlePageClick(page)}
              style={{
                marginRight: "5px",
                backgroundColor: currentPage === page ? "#007bff" : "#fff",
                color: currentPage === page ? "#fff" : "#000",
              }}
            >
              {page}
            </button>
          ))}
          <button onClick={handleNextPage}>After</button>
          <button onClick={handleLastPage}>Last</button>
        </div>
      )} */}
    </div>
  );
}

export default EmployeeTable;
